import React from 'react';
const IconMiscSteps = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 17.09V21.09H21V3.08997H13V8.08997H8V13.09H3V15.09H10V10.09H15V5.08997H19V19.09H5V17.09H3Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconMiscSteps;